import { useState, useEffect } from 'react';
import api from '../../../services/api';
import DataTable from '../componentes/DataTable';
import EditModal from '../componentes/EditModal';
import DeleteConfirm from '../componentes/DeleteConfirm';
import { Plus } from 'lucide-react';

const SociosPanel = () => {
  const [socios, setSocios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selected, setSelected] = useState(null);
  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [logoFile, setLogoFile] = useState(null);

  const fetchSocios = async () => {
    try {
      setLoading(true);
      const res = await api.get('/socios');
      setSocios(res.data?.data || res.data || []);
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchSocios(); }, []);

  const handleEdit = (s) => {
    setSelected({ ...s });
    setLogoFile(null);
    setShowEdit(true);
  };

  const handleCreate = () => {
    setSelected(null);
    setLogoFile(null);
    setShowEdit(true);
  };

  const handleDelete = (id) => {
    setSelected(socios.find(s => s.id === id));
    setShowDelete(true);
  };

  const handleSave = async (formData) => {
    let socioId = selected?.id;
    const payload = { ...formData };
    delete payload.imagen; // por si acaso

    if (selected) {
      await api.put(`/socios/${selected.id}`, payload);
    } else {
      const res = await api.post('/socios', payload);
      socioId = res.data?.id || res.data?.socio?.id;
      if (!socioId) throw new Error('No se pudo crear el socio');
    }

    if (logoFile) {
      const logoForm = new FormData();
      logoForm.append('imagen', logoFile);
      await api.post(`/upload-socio/${socioId}`, logoForm);
    }

    setShowEdit(false);
    fetchSocios();
  };

  const confirmDelete = async () => {
    await api.delete(`/socios/${selected.id}`);
    setShowDelete(false);
    fetchSocios();
  };

  const columns = [
    { key: 'id', label: 'ID' },
    { key: 'nombre_local', label: 'Nombre' },
    { key: 'categoria', label: 'Categoría' },
    { key: 'direccion', label: 'Dirección' },
    { key: 'telefono', label: 'Teléfono' },
  ];

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.25rem' }}>
        <h1 style={{ fontSize: '1.5rem', fontWeight: 800 }}>Socios comerciales</h1>
        <button className="sp-btn sp-btn--primary" onClick={handleCreate}>
          <Plus size={18} /> Nuevo
        </button>
      </div>

      <DataTable
        columns={columns}
        data={socios}
        loading={loading}
        error={error}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />

      {showEdit && (
        <EditModal
          title={selected ? 'Editar socio' : 'Crear socio'}
          fields={[
            { name: 'nombre_local', label: 'Nombre del local' },
            { name: 'categoria', label: 'Categoría' },
            { name: 'descripcion', label: 'Descripción', type: 'textarea' },
            { name: 'direccion', label: 'Dirección' },
            { name: 'telefono', label: 'Teléfono' },
            { name: 'email', label: 'Email', type: 'email' },
            { name: 'sitio_web', label: 'Sitio web' },
            { name: 'horarios', label: 'Horarios' },
            { name: 'latitud', label: 'Latitud', type: 'number', step: 'any' },
            { name: 'longitud', label: 'Longitud', type: 'number', step: 'any' },
            { name: 'activo', label: 'Activo', type: 'checkbox' },
            { name: 'imagen', label: 'Logo', type: 'file', accept: 'image/*', onChange: (e) => setLogoFile(e.target.files[0]) },
          ]}
          initialValues={selected || {}}
          onSave={handleSave}
          onCancel={() => setShowEdit(false)}
        />
      )}

      {showDelete && (
        <DeleteConfirm
          message={`¿Eliminar al socio ${selected.nombre_local}?`}
          onConfirm={confirmDelete}
          onCancel={() => setShowDelete(false)}
        />
      )}
    </div>
  );
};

export default SociosPanel;